// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonBaseContent_wrapper__jGFxJ","icon":"ButtonBaseContent_icon__w5JSD","left":"ButtonBaseContent_left__nLkXn","right":"ButtonBaseContent_right__WAjXc"};